import { useCallback, useEffect, useRef, useState } from 'react';

import api from '../../../utils/functions/api';
import { sumRemaining } from '../components/dialogs/DebtNoteDetailDialog';

// ยอด "คงเหลือรวม" ของการ์ด "เจ้าหนี้" (แท็บ เจ้าหนี้ / ลูกหนี้) — ใช้สูตรเดียวกับการ์ดนั้นเป๊ะ (sumRemaining)
// ให้แท็บ "ยืม-คืน" เอาไปรวมเป็น "หนี้รวมทั้งหมด" ได้โดยไม่ต้องเปิดแท็บเจ้าหนี้ก่อน
// creditorRemaining = null ระหว่างโหลด หรือโหลดไม่สำเร็จ (ให้ผู้เรียกแสดง "-" ไม่ใช่ 0 ที่ดูเหมือนไม่มีหนี้)
export function useCreditorRemaining() {
  const [creditorRemaining, setCreditorRemaining] = useState(null);
  const mounted = useRef(true);

  const reloadCreditor = useCallback(async () => {
    try {
      const { data } = await api.get(`${process.env.REACT_APP_API_URL}/debt-note?category=CREDITOR`);
      if (mounted.current) setCreditorRemaining(sumRemaining(Array.isArray(data) ? data : []));
    } catch (error) {
      if (mounted.current) setCreditorRemaining(null);
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    reloadCreditor();

    return () => { mounted.current = false; };
  }, [reloadCreditor]);

  return { creditorRemaining, reloadCreditor };
}

export default useCreditorRemaining;
